export default __webpack_public_path__ + "static/globe-5-1d84e4d67e5d447fddf4c6ebe832aee0.png";